require('jquery');

$(() =>
{
    $('[data-bs-toggle="tooltip"]').tooltip();
});
